import { render, staticRenderFns } from "./Version.vue?vue&type=template&id=91db70e4&"
import script from "./Version.vue?vue&type=script&lang=js&"
export * from "./Version.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\git\\cdmgtri\\niem-mapping-app\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('91db70e4')) {
      api.createRecord('91db70e4', component.options)
    } else {
      api.reload('91db70e4', component.options)
    }
    module.hot.accept("./Version.vue?vue&type=template&id=91db70e4&", function () {
      api.rerender('91db70e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Version.vue"
export default component.exports